// import Repository from '@/libs/axios'
import ReportRepository from '@/libs/customAxios/reportsAxios'
import DashboardRepository from '@/libs/customAxios/dashboardAxios'

const reportFinanceResource = '/merchant/report/finance-report'
const deliveryOrdersResource = '/merchant/report/delivery-orders-report'
const returnOrdersResource = '/merchant/report/return-orders-report'
const deliveryOrdersOverviewResource = '/merchant/report/delivery-orders-report-overview'
const returnOrdersOverviewResource = '/merchant/report/return-orders-report-overview'
const financeOrdersOverviewResource = '/merchant/report/finance-report-overview'

const defaultPagination = 10
export default {
  getOrderStatsFinance(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return ReportRepository.get(`${reportFinanceResource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getOrderStatsFinanceNoPagination(filterQuery, sort) {
    return ReportRepository.get(`${reportFinanceResource}?sort=${sort}&${filterQuery}&noPagination`)
  },
  getDeliveryOrdersFinance(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return ReportRepository.get(`${deliveryOrdersResource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getDeliveryOrdersFinanceNoPagination(filterQuery, sort) {
    return ReportRepository.get(`${deliveryOrdersResource}?sort=${sort}&${filterQuery}&noPagination`)
  },
  getReturnOrdersFinance(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return ReportRepository.get(`${returnOrdersResource}?paginate=${pagination}&page=${pageNumber}&sort=${sort}&${filterQuery}`)
  },
  getReturnOrdersFinanceNoPagination(filterQuery, sort) {
    return ReportRepository.get(`${returnOrdersResource}?sort=${sort}&${filterQuery}&noPagination`)
  },
  getDeliveryOrdersReportOverview() {
    return DashboardRepository.get(`${deliveryOrdersOverviewResource}`)
  },
  getReturnOrdersReportOverview() {
    return DashboardRepository.get(`${returnOrdersOverviewResource}`)
  },
  getFinanceOrdersReportOverview() {
    return DashboardRepository.get(`${financeOrdersOverviewResource}`)
  },
  fetchReportDownloads(filterQuery, pageNumber = 1, pagination = defaultPagination) {
    return ReportRepository.get(`/merchant/report/get-queued-reports?${filterQuery}&page=${pageNumber}&paginate=${pagination}`, {
    })
  },
  fetchReportDownloadsNoPagination(filterQuery) {
    return ReportRepository.get(`/merchant/report/get-queued-reports?${filterQuery}`, {
    })
  },
}
